/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Edit_Freight_Locked_By_ShipmentInputs */

const vi_order_edit_freight_locked_by_shipment = /** @type {(inputs: Order_Edit_Freight_Locked_By_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã có vận đơn hãng. Hãy huỷ vận đơn trước nếu khách hàng cần trả cước.`)
};

/**

* @param {Order_Edit_Freight_Locked_By_ShipmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_edit_freight_locked_by_shipment = /** @type {((inputs?: Order_Edit_Freight_Locked_By_ShipmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Edit_Freight_Locked_By_ShipmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_edit_freight_locked_by_shipment(inputs)
});